import * as Constants from '../constants';

const initialState = {
  patientsList: [],
  loading: false,
  selectedPatient: {},
  selectedAddress: {},
};
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case Constants.ADD_PATIENT_START:
    case Constants.DELETE_PATIENT_START:
    case Constants.FETCH_PATIENTS_START:
    case Constants.UPDATE_PATIENT_START:
      return Object.assign({
        loading: true
      });
    case Constants.ADD_PATIENT_SUCCESS:
      return {
        // data: action.data,
        ...state,
        loading: false
      };
    case Constants.DELETE_PATIENT_SUCCESS:
      return {
        // data: action.data,
        ...state,
        loading: false
      };
    case Constants.FETCH_PATIENTS_SUCCESS:
      return {
        // data: action.data,
        ...state,
        patientsList: action.data.data,
        loading: false
      };
    case Constants.UPDATE_PATIENT_SUCCESS:
      return {
        // data: action.data,
        ...state,
        loading: false
      };
    case Constants.SELECT_PATIENT_SUCCESS:
      return {
        ...state,
        selectedPatient: action.data,
      };
    case Constants.SELECT_ADDRESS_DIAGNOSTICS_SUCCESS:
      return {
        ...state,
        selectedAddress: action.data,
      };
    case Constants.ADD_PATIENT_FAILURE:
    case Constants.DELETE_PATIENT_FAILURE:
    case Constants.FETCH_PATIENTS_FAILURE:
    case Constants.UPDATE_PATIENT_FAILURE:
      return Object.assign({}, state, {
        // data: action.data,
        loading: false
      });
    case Constants.SET_SELECTED_GENDER:
      return {
        ...state,
        selectedGender: action.data,
      };
    default:
      return {
        ...state
      };
  }
}
